import Swiper, { Navigation } from "swiper";
document.addEventListener("DOMContentLoaded", (event) => {
	document.querySelectorAll(".js-offer-slider").forEach(($wrapper) => {
		const $block = $wrapper.closest(".offers-slider");
		const $nextEl = $block.querySelector(".slider-buttons__item--next");
		const $prevEl = $block.querySelector(".slider-buttons__item--prev");

		//init slider
		const swiper = new Swiper($wrapper, {
			modules: [Navigation],
			slidesPerView: "auto",
			spaceBetween: 30,
			centeredSlides: true,
			navigation: {
				nextEl: $nextEl,
				prevEl: $prevEl,
			},
		});

		//listen slide change
		swiper.on("slideChange", function () {
			const $slide = $block.querySelector(
				`.swiper-slide[data-index="${swiper.realIndex}"]`
			);
			const color = $slide.getAttribute("data-color");
			$block.style.setProperty("--theme-primary", color);
		});
	});
});
